import { render, staticRenderFns } from "./ModalTransfer.vue?vue&type=template&id=c6c7c76a&scoped=true"
import script from "./ModalTransfer.vue?vue&type=script&lang=js"
export * from "./ModalTransfer.vue?vue&type=script&lang=js"
import style0 from "./ModalTransfer.vue?vue&type=style&index=0&id=c6c7c76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c7c76a",
  null
  
)

export default component.exports